export default "__VITE_ASSET__c5e06891__"